export default function cloudURL() {
  const xobj = new XMLHttpRequest();
  xobj.overrideMimeType("application/json");
  xobj.open("GET", `${window.location.origin}/config.json`, false);
  xobj.send(null);
  let cloudRoute = "";
  if (xobj.status === 200) {
    cloudRoute = JSON.parse(xobj.responseText).cloudHost;
  }
  return cloudRoute;
}
